import {gsap} from "gsap";
import { ScrollTrigger, ScrollSmoother, SplitText, ScrollToPlugin} from "gsap/all";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, ScrollToPlugin);

export default class Animations {
    constructor() {
        this.smoothScroll();
        this.animeSectionTitle();
        this.animeShortDesc();
    }

    smoothScroll = () => {
        this.smoother = ScrollSmoother.create({
            smooth: 1,
            effects: true,
            smoothTouch: 0.1,
            normalizeScroll: true,
            wrapper: ".smooth-wrapper",
            content: ".smooth-content",
        });

        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const targetId = this.getAttribute('href');

                gsap.to(window, {
                    duration: 1,
                    scrollTo: {
                        y: targetId,
                        offsetY: 80 // Hauteur de ton header si fixe
                    },
                    ease: "power2.inOut"
                });
            });
        });
    }

    animeSectionTitle = () => {
        const titleSections = document.querySelectorAll('.titleSection')

        titleSections.forEach(section => {

            const bar = section.querySelector('.bar');
            const title = section.querySelector('.title');

            gsap.from(title, {
                ease: "power1.ease",
                opacity: 0,
                y: 150,
                scrollTrigger: {
                    trigger: section,
                    start: "0% 95%",
                    end: "200% 80%",
                    scrub: true,
                }
            });

            gsap.from(bar, {
                ease: "power1.ease",
                width: 0,
                scrollTrigger: {
                    trigger: section,
                    start: "0% 100%",
                    end: "100% 80%",
                    scrub: true,
                }
            });
        })
    }


    animeShortDesc = () => {
        document.querySelectorAll('.shortdesc').forEach((el) => {
            gsap.from(el, {
                opacity: 0,
                scrollTrigger: {
                    trigger: el,
                    scrub: true,
                    start: 'top 85%',
                    end: '0% 40%',
                }
            });
        });
    }
}